










import VueOptions from '@utils/VueOptions'
import FormBuilder from '@ui/FormBuilder/FormBuilder'
import VenueFields from '@ui/FormBuilder/ResourceFields/VenueFields.coffee'

settings =
  name: 'VenueAdvancedSettingsForm'

  vue:
    props: ['form', 'mediaKits', 'actions']

    components: {
      FormBuilder,
    }

    computed:
      contextForVenueFields: ->
        options:
          type: @toSelectOptions(@$store.marketplace?.brand?.categories)
          preferred_brand_categories: @toSelectOptions(@$store.marketplace?.brand?.categories)
          images: @mediaKits
        inputProps:
          images:
            tags: ['venue']

      venueFields: ->
        VenueFields(@contextForVenueFields)

export default VueOptions.vue settings
